import styled from 'styled-components';
import device from '../../mediaQueries';

const Wrapper = styled.div`
  padding-bottom: 150px;
  ${device.mobile`
    padding: 2.5% 5%
  `}
`;

export default Wrapper;
